import { fieldStyle } from '../../dashboards/primitives';
import { Field, MONO } from '../../dashboards/venues/venueCreateFields';

import { requiredProps, TWO_COLUMNS } from './step-layout';
import type { WhenWhatFormApi } from './when-what-form-api';

/** Workshop type, date and start/end time, common to every location kind. */
export default function WorkshopTypeDateTimeFields({ form }: { form: WhenWhatFormApi }) {
  const { fields, set, types, minDate, fieldError } = form;
  const dateError = fieldError('startsAt');
  const startError = fieldError('startTime');
  const endError = fieldError('endTime') ?? fieldError('endsAt');
  const typeError = fieldError('workshopTypeId');
  return (
    <>
      <Field label="Workshop type" required error={typeError}>
        <select
          aria-label="Workshop type"
          {...requiredProps(typeError)}
          value={fields.workshopTypeId}
          onChange={(e) => set('workshopTypeId', e.target.value)}
          style={fieldStyle(typeError ? 'error' : undefined)}
        >
          <option value="">Select a type…</option>
          {types.map((t) => (
            <option key={t.id} value={t.id}>
              {t.displayName ?? t.name}
            </option>
          ))}
        </select>
      </Field>
      <Field label="Date" required error={dateError}>
        <input
          type="date"
          aria-label="Date"
          {...requiredProps(dateError)}
          className="nb-dt-input"
          min={minDate}
          value={fields.date}
          onChange={(e) => set('date', e.target.value)}
          style={fieldStyle(dateError ? 'error' : undefined, { fontFamily: MONO })}
        />
      </Field>
      <div style={TWO_COLUMNS}>
        <Field label="Start time" required error={startError}>
          <input
            type="time"
            aria-label="Start time"
            {...requiredProps(startError)}
            className="nb-dt-input"
            value={fields.startTime}
            onChange={(e) => set('startTime', e.target.value)}
            style={fieldStyle(startError ? 'error' : undefined, { fontFamily: MONO })}
          />
        </Field>
        <Field label="End time" required error={endError}>
          <input
            type="time"
            aria-label="End time"
            {...requiredProps(endError)}
            className="nb-dt-input"
            value={fields.endTime}
            onChange={(e) => set('endTime', e.target.value)}
            style={fieldStyle(endError ? 'error' : undefined, { fontFamily: MONO })}
          />
        </Field>
      </div>
    </>
  );
}
